module.exports = __webpack_public_path__ + "img/icon_smart_meeting.f9859124.png";